import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ModalService } from '../../../../services/modal.service';
import { showErrorMessage } from '../../../../utils/utils';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { CampaignStatusPipe } from '../../../../pipes/campaignStatus.pipe';
import { Page } from '../../../../models/page.model';
import { ARBleCampaign, ARBleCampaignConfiguration } from '../../../../models/agrorendement-ble.model';
import { ARBleService } from '../../../../services/agrorendement-ble.service';
import { ARBleCampaignConfigurationEditComponent } from './campaign-config-edit.component';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-ble-campaigns-cmp',
  templateUrl: 'campaigns.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ARBleCampaignConfigurationEditComponent, CampaignYearPipe, CampaignStatusPipe, TranslatePipe, CommonModule, FormsModule, PaginationModule],
  providers: [ARBleService],
})
export class ARBleCampaignComponent implements OnInit, AfterViewInit {
  error: any;

  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public filter: string = '';

  constructor(
    private bleService: ARBleService,
    private modal: ModalService,
    private router: Router,
  ) {}

  getCampaignsPaginated(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: string) {
    this.bleService
      .getPageCampaigns(pageIndex, this.itemsPerPage, sortColumnName, sortColumnOrder, filter)
      .subscribe((page) => this.handlePage(page));
  }

  handlePage(page: Page<ARBleCampaign>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
  }

  addCampaignConfiguration(campaign: ARBleCampaign) {
    this.router.navigate(['/orders', 'azote', 'ble', 'admin', 'campaigns', 'new', campaign.id]);
  }

  deleteCampaignConfiguration(config: ARBleCampaignConfiguration, event: any) {
    event.stopPropagation();
    // FIXME traiter les erreurs
    this.bleService.deleteCampaignConfiguration(config).subscribe(
      (res) => {
        this.onChangeTable();
      },
      (error) => this.handleError(error, 'Impossible de supprimer la configuration'),
    );
  }

  handleError(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      console.error(error);
      showErrorMessage(this.modal, msg);
    }
  }

  editCampaignConfiguration(config: ARBleCampaignConfiguration, event: any) {
    this.router.navigate(['/orders', 'azote', 'ble', 'admin', 'campaigns', 'edit', config.id]);
  }

  ngOnInit() {
    this.onChangeTable();
  }

  ngAfterViewInit() {}

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    const pageNumber = page.page;
    this.getCampaignsPaginated(pageNumber, null, null, this.filter);
  }
}
